<template>
    <section class="recent-wrapper">
        <div class="container">
            <div class="withdraw-sec">
                <div class="upi-title">
                    <label>{{$t('choose-from-recent-accounts','Choose From Recent Accounts')}}</label>
                    <label class="withdraw_title_amount_cl">{{$t('amount','Amount')}}:  <span>{{ withdrawAmount }}</span></label>
                </div>
                <div class="recent-main recent-sec checkbox-pad" :class="{'show' : accountId == account.client_account_id}" v-for="(account, index) in userAccounts" :key="index">
                    <label class="d-flex w-100 justify-content-between" :for="'withdrawAcount' + index">
                        <div class="form-check">
                            <input class="form-check-input" type="radio" name="flexRadioDefault" :id="'withdrawAcount' + index"  :value="account.client_account_id"
                            v-model="accountId" @change="selectUserAccount(account)" />
                            <div class="form-check-label">
                                <div class="recent-bank-sec">
                                    <div class="recent-bank">
                                        <div class="bank-icon">
                                            <img :src="imageCollection[account?.method_name?.toLowerCase()]" alt="methods" loading="lazy" />
                                        </div>
                                        <div class="bank-con">
                                            <p class="para-six">{{ account.bank_name ? account.bank_name : account.payment_type_name }}</p>
                                            <span>{{ account.account_holder_name }}</span>
                                            <span v-if="account.account_number">{{ account.account_number}} / {{ account.ifsc_code}}</span>
                                            <span v-else>{{ account.upi_id ? account.upi_id :account.crypto_wallet_id }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="menu-dots align-content-center">
                            <div class="btn-group dropstart">
                                <button type="button" class="border-0 bg-transparent dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                    <img class="dotts-img" src="@/assets/images/menu-dots.svg" alt="menu-dots" loading="lazy" />
                                </button>
                                <ul class="remove-main dropdown-menu">
                                    <button class="border-0 bg-transparent remove_acc_btn">
                                        <div class="remove-sec">
                                            <div class="remove-icon">
                                                <img src="@/assets/images/remove-icon.svg" alt="remove-icon" loading="lazy" />
                                            </div>
                                            <div class="remove-con" @click="handleRemoveAccount(account)">
                                                <span>{{$t('remove-account','Remove account')}}</span>
                                            </div>
                                        </div>
                                    </button>
                                </ul>
                            </div>
                        </div>
                    </label>
                </div>
                <div class="back_btn_cl mt-2" v-if="withdrawAccountType">
                    <button @click="validateWithdrawAmount()" type="button" class="thm-but back_btn_link withdraw_btn_cl" id="account-successfully">Withdraw {{ withdrawAmount}} to {{ withdrawAccountType?.type }} ({{withdrawAccountType?.holderName}})</button>
                </div>
            </div>
            <div class="withdraw-sec">
                <div class="new-account-wrapper">
                    <div class="upi-title">
                        <label>{{$t('add-a-new-account','Add a new account')}}</label>
                    </div>
                    <div class="bankAccount-wrap">
                        <template v-for="(account, index) in paymentMethodList" :key="index">
                            <a @click="goToAccountDetails(account)" href="javascript:void(0);" class="bankAccount-item header-bg">
                                <div class="bankAccount-icon">
                                    <img loading="lazy" :src="account.icon" alt="bank icon">
                                </div>
                                <div class="bankAccount-title">{{ account.method_name }}</div>
                                <div class="bankAccount-arrow">
                                    <img loading="lazy" src="@/assets/images/arrow-right-icon.svg" alt="arrow right">
                                </div>
                            </a>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <!-- <ApprovalBeforeRemoving :getUserAccounts="getUserAccounts" :selectedAccount="selectedAccount"/> -->
    </section>
    <Confirmation
        @confirm="confirmDelete"
        @cancel="$helper.closeModal('deleteConfirmationModal')"
    />
    <TwoFAModal
		v-if="show2FAModal"
		:loading="twoFaLoading"
		@close="show2FAModal = false"
		@verify="verifyTwoFa"
	/>
    <TransactionPasswordModal />
</template>

<script>
import { mapGetters } from 'vuex';
import { check2FaStatus, getUserAccounts, withdrawWalletAmount, removeAccount } from '@template/utils'
import ApprovalBeforeRemoving from '../components/ApprovalBeforeRemoving.vue';
import Confirmation from '@/shared/components/confirmation/Confirmation.vue';
import TwoFAModal from '@/modules/2FA/components/TwoFAModal.vue';
import TransactionPasswordModal from '@/modules/wallet/components/TransactionPasswordModal.vue';

export default {
    name: 'WithdrawDetails',
    inject: ['walletConfig'],
    data(){
        return{
            paymentMethodList: null,
            s3Url: null,
            userAccounts: null,
            s3UrlUserAccount: null,
            selectedAccount: null,
            accountId: null,
            bankUrl: null,
            withdrawAccountType: '',
            imageCollection: {},
            // 2FA
            show2FAModal:false,
            twoFaLoading:false
        }
    },
    components:{
        ApprovalBeforeRemoving,
        Confirmation,
        TwoFAModal,
        TransactionPasswordModal,
    },
    computed: {
        ...mapGetters([
            'withdrawAmount'
        ])
    },
    created(){
        this.getUserAccounts();
        this.fetchImages();
    },
    methods:{
        async verifyTwoFa(otp){
			this.twoFaLoading = true
			// const response = await verifyTwoFa(otp)
            this.withdrawWalletAmount(otp)
            this.show2FAModal = false
            this.twoFaLoading = false
            // else if(response.error && response?.is2faDisabled){
            //     this.show2FAModal = false
            // }
		},
		check2FaStatus(){
           const response = check2FaStatus();
            if(response?.is2faEnabled){
                this.show2FAModal = true
           }else{
                this.withdrawWalletAmount()
           }
        },
        fetchImages(){
            this.walletConfig?.payment_method.forEach(method =>{
                this.imageCollection[method.method_name.toLowerCase()] = method.icon
            })
            this.walletConfig?.bank_list.forEach(method =>{
                this.imageCollection[method.bank_name.toLowerCase()] = method.icon
            })
        },
        handleRemoveAccount(account){
            this.selectedAccount = account;
            // this.$helper.openModal('#approvalBeforeRemoving')
            this.$helper.openModal('#deleteConfirmationModal')
        },
        async confirmDelete() {
            this.$helper.closeModal('deleteConfirmationModal')
            await this.removeAccount();
        },
        async removeAccount(){
            let response = await removeAccount(this.selectedAccount.client_account_id)
            if(response) {
                this.getUserAccounts();
            }
        },
        async getUserAccounts() {
            let response = await getUserAccounts(this.walletConfig?.payment_method)
            this.userAccounts = response.userAccounts;
            this.withdrawAccountType = response.withdrawAccountType;
            this.paymentMethodList = response.paymentMethods;
            if(this.userAccounts && this.userAccounts.length > 0) {
                this.selectUserAccount (this.userAccounts?.[0]);
            }
            if(!response?.metaInfo?.has_transaction_password){
                this.$helper.openModal('#setTransactionPasswordModel');  
            }
        },
        goToAccountDetails(account){
            this.$store.dispatch('setPaymentMethodDetails', account)
            this.$router.push({
                name:'WithdrawAccountDetails',
                params:{
                    type: account.method_type,
                    id: account.id
                }
            })
        },
        validateWithdrawAmount(){
            if (this.withdrawAmount > this.$auth?.user?.balance) {
                this.$errorToast('Insufficient balance.');
                return false;
            }
            this.check2FaStatus()
        },
        async withdrawWalletAmount(otp = null){
            this.$store.dispatch('setGlobalLoader', true);
            let response = await withdrawWalletAmount(this.withdrawAmount, this.accountId , otp)
            this.$store.dispatch('setGlobalLoader', false);
            if(!response?.error){
                this.$router.push({ name: 'Home' });
            }
        },
        selectUserAccount(account){
            this.accountId = account.client_account_id;
            this.withdrawAccountType = {
                type : account.bank_name ? account.bank_name : account.payment_type_name,
                holderName: account.account_holder_name
            };
        }
    }
}
</script>